import React from "react";

import { templates } from "@reactivated";

import { PDPChangeRootProductBlock } from "../apps/configurator/PDPChangeRootProductBlock";

export const Template = (
    props: templates.ChangeRootProductBlockTemplate,
): React.JSX.Element => {
    return (
        <div>
            <PDPChangeRootProductBlock
                inputType={props.input_type}
                initialRootProductsData={props.initial_root_products_data}
                initialSelectedRootProductId={
                    props.initial_selected_root_product_id
                }
            />
        </div>
    );
};
